/** Composer and tesoro share these caps so a 300 MB file or a 101st attachment is refused with the limit named. */ export const MAX_UPLOAD_BYTES = 250 * 1024 * 1024;
export const MAX_FILES_PER_MESSAGE = 100;
export function partitionComposerFiles(files, alreadyQueued) {
    const accepted = [];
    const oversized = [];
    let overCount = 0;
    for (const file of files){
        if (file.size > MAX_UPLOAD_BYTES) {
            oversized.push(`${file.name} (${(file.size / (1024 * 1024)).toFixed(2)}MB)`);
            continue;
        }
        if (alreadyQueued + accepted.length >= MAX_FILES_PER_MESSAGE) {
            overCount++;
            continue;
        }
        accepted.push(file);
    }
    return {
        accepted,
        oversized,
        overCount
    };
}
export function describeComposerFileCaps(oversized, overCount) {
    const parts = [];
    if (oversized.length) {
        parts.push(`The following files exceed the 250MB limit and cannot be uploaded:\n\n${oversized.join('\n')}`);
    }
    if (overCount) {
        parts.push(`${overCount} file${overCount === 1 ? '' : 's'} not attached — a message can take ${MAX_FILES_PER_MESSAGE} files.`);
    }
    return parts.join('\n\n');
}
